import {
    Component,
    ViewEncapsulation,
    Input,
    forwardRef,
    EventEmitter,
    OnInit,
} from '@angular/core';
import {
    ControlValueAccessor,
    NG_VALUE_ACCESSOR,
    FormGroupDirective,
    AbstractControl,
    ControlContainer,
} from '@angular/forms';
import { ReactiveFormsService } from '../../providers/reactive-forms.service';

@Component({
    selector: 'roblex-input-date-picker',
    templateUrl: './input-date-picker.component.html',
    styleUrls: ['./input-date-picker.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => InputDatepickerComponent),
        },
    ],
})
export class InputDatepickerComponent implements OnInit, ControlValueAccessor {
    /**
     * Control  of input form field component
     */
    control: AbstractControl;
    /**
     * Value  of input field component
     */
    _value = '';
    /**
     * Input  of input form field component
     */
    @Input() formControlName: string;
    /**
     * Input  of input form field component
     */
    @Input() appearance: 'standard' | 'fill' | 'outline' = 'outline';
    /**
     * Input  of input field component
     */
    @Input() label = 'date picker label';
    /**
     * Input  of input field component
     */
    @Input() disabled = false;
    /**
     * Input  of input field component
     */
    @Input() placeholder = '';
    /**
     * Input  of input datepicker component
     */
    @Input() change: EventEmitter<any> = new EventEmitter();
    /**
     * Gets value
     */
    get value() {
        return this._value;
    }
    /**
     * Sets value
     */
    set value(val) {
        this._value = val;
        this.onChangeCallback(this._value);
    }
    /**
     * Gets form
     */
    get form() {
        return this.controlContainer.formDirective
            ? (this.controlContainer.formDirective as FormGroupDirective).form
            : null;
    }
    /**
     * Determines whether touched callback on
     */
    onTouchedCallback: () => void;
    /**
     * Propagate change of input field component
     */
    onChangeCallback = (_: any) => {};
    /**
     * Creates an instance of input form field component.
     * @param controlContainer ControlContainer
     */
    constructor(public controlContainer: ControlContainer) {}
    /**
     * on init
     */
    ngOnInit(): void {
        this.control = this.form.get(this.formControlName);
    }
    /**
     * Gets error message
     */
    getErrorMessage() {
        if (this.control) {
            return ReactiveFormsService.errorMessage(this.control);
        }
        return null;
    }
    /**
     * Determines whether change event on
     * @param value any
     */
    onDateInput(value: any) {
        // this.writeValue(value);
        if (this.control) {
            this.control.markAsTouched();
        }
    }
    /**
     * Determines whether date change on
     * @param value any
     */
    onDateChange(event: any) {
        const value =
            typeof event.value !== 'string'
                ? event.value.toISOString()
                : event.value;

        this.change.emit(value);
        this.writeValue(value);
    }
    /**
     * Writes value
     * @param value any
     */
    writeValue(value: any): void {
        this.value = value;
        this.onChangeCallback(this.value);
    }
    /**
     * Registers on change
     * @param fn any
     */
    registerOnChange(fn: any): void {
        this.onChangeCallback = fn;
    }
    /**
     * Registers on touched
     * @param fn any
     */
    registerOnTouched(fn: any): void {
        this.onTouchedCallback = fn;
    }
    /**
     * Sets disabled state
     * @param isDisabled boolean
     */
    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }
}
